import { render, staticRenderFns } from "./ProfilePendingList.vue?vue&type=template&id=1ac41fdf&"
import script from "./ProfilePendingList.vue?vue&type=script&lang=js&"
export * from "./ProfilePendingList.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePendingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports